import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, e, r, d, t, s, v, n, u, a, c) {
    super(
      i,
      void 0,
      void 0,
      o,
      e,
      void 0,
      void 0,
      void 0,
      (r = r || InAppMessage.DismissType.MANUAL),
      d,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
      c,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  Po() {
    return !1;
  }
  $t(i) {
    if (this.uo === InAppMessage.bo.Ur) {
      if (this.So) return !1;
      this.So = !0;
    }
    return this.ti.X(i), !0;
  }
  bt() {
    const i = super.bt(HtmlMessage.cs);
    return (i[InAppMessage.es.Eo] = this.messageFields), i;
  }
  static Qr(i) {
    return new HtmlMessage(
      i[InAppMessage.es.ra],
      i[InAppMessage.es.qs],
      i[InAppMessage.es.ta],
      i[InAppMessage.es.pa],
      i[InAppMessage.es.ma],
      i[InAppMessage.es.ja],
      i[InAppMessage.es.xa],
      i[InAppMessage.es.wa],
      i[InAppMessage.es.ka],
      i[InAppMessage.es.CSS],
      i[InAppMessage.es.Eo],
      i[InAppMessage.es.qa],
    );
  }
}
HtmlMessage.cs = InAppMessage.bo.Ur;
